import React from "react";

interface Props {
    footer: any;
}

const bg: any = [];
const bg_rand = bg[Math.floor(Math.random() * 5)];

const _404: React.FC<Props> = ({ footer }) => {
    return (
        <>
            <div id="login">
                <div>
                    <h2>
                        404
                        <br />
                        Page Not Found
                    </h2>
                    <div className="mt-4 h3">
                        <a href="/">Home</a>
                    </div>
                    {footer}
                </div>
                <div className="position-relative" style={{ backgroundColor: "#155bd5" }}>
                    <div className="auth-bg-msg"></div>
                </div>
            </div>
        </>
    );
};

export default _404;
